function showStatusFactory() {
  return (appointmentStatus: string, buttonStatus: string) => {
    if (buttonStatus === 'confirm') {
      return (
        appointmentStatus === 'time_change' ||
        appointmentStatus === 'new' ||
        appointmentStatus === 'attempted'
      );
    }

    if (buttonStatus === 'cancel') {
      return (
        appointmentStatus === 'confirm' ||
        appointmentStatus === 'attempted' ||
        appointmentStatus === 'time_change' ||
        appointmentStatus === 'new' ||
        appointmentStatus === 'time_passed'
      );
    }

    if (buttonStatus === 'time_change') {
      return (
        appointmentStatus === 'new' ||
        appointmentStatus === 'confirm' ||
        appointmentStatus === 'attempted' ||
        appointmentStatus === 'time_change'
      );
    }

    if (buttonStatus === 'deny') {
      return (
        appointmentStatus === 'time_change' ||
        appointmentStatus === 'attempted' ||
        appointmentStatus === 'new'
      );
    }

    if (buttonStatus === 'attempted') {
      return (
        appointmentStatus === 'time_change' ||
        appointmentStatus === 'new' ||
        appointmentStatus === 'attempted'
      );
    }

    return false;
  };
}

export default showStatusFactory;
